import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToTop = (
  scrollContainerRef: React.RefObject<HTMLElement>,
) => {
  const location = useLocation();

  useEffect(() => {
    const el = scrollContainerRef.current;
    if (el) {
      el.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [location.pathname]);
};
